<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="phone：">
          <el-input v-model="searchValue.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="searchWhitePhoneList"
            >查询</el-button
          >
          <el-button type="success" plain @click="addWhitePhoneDialog"
            >新增白名单</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- phone白名单列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="150"> </el-table-column>
      <el-table-column prop="created_at" label="创建日期"> </el-table-column>
      <el-table-column prop="phone" label="手机号码"> </el-table-column>
      <el-table-column prop="admin.name" label="操作人员"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" plain @click="del_whitePhone(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 添加白名单弹出框 -->
    <el-dialog
      title="添加白名单"
      :visible.sync="addDialogFormVisible"
      width="28%"
      class="addWhite"
    >
      <el-form>
        <el-form-item label="phone:">
          <el-input v-model="phone"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addWhitePhoneSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
export default {
  name: "users",
  components: {},
  data() {
    return {
      loadingData: false,
      addDialogFormVisible: false,
      searchValue: {
        phone: "",
      },
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      phone: "",
      remark: "",
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getWhitePhoneList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getWhitePhoneList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getWhitePhoneList(false);
    },
    // 实现游戏数据搜索
    searchWhitePhoneList() {
      this.currentPage = 1;
      this.getWhitePhoneList(true);
    },
    // 删除
    del_whitePhone(id) {
      this.$confirm("是否确定删除该数据?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del_whitePhoneSubmit(id);
        })
        .catch(() => {});
    },
    del_whitePhoneSubmit(id) {
      fetch({
        url: "/admin/white_phones/delete",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getWhitePhoneList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 新增白名单
    addWhitePhoneDialog() {
      this.phone = "";
      this.remark = ""
      this.addDialogFormVisible = true;
    },
    // 新增白名单提交操作
    addWhitePhoneSubmit() {
      fetch({
        url: "/admin/white_phones/add",
        method: "POST",
        data: {
          phone: this.phone,
          remark: this.remark,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "新增白名单成功！",
          });
          this.addDialogFormVisible = false;
          this.getWhitePhoneList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示phone拉黑列表数据
    getWhitePhoneList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/white_phones/list",
        method: "GET",
        params: {
          ...searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.addWhite {
  .el-form-item {
    display: flex;
    // justify-content: center;
    .el-input {
      width: 320px;
    }
  }
}
</style>
